/* Card price, fabric and Quick Add follow the colour swatch. Sept 25 2026.

   mm-card-swatches.js repaints the image, colour name, labels and badge when a
   swatch is picked, but not the price or the fabric line, because the family
   data on the card carries neither. A swatch can land on a sibling at another
   price or in another fabric, so the card showed one product's picture with
   another product's price.

   Kept in its own file rather than added to mm-card-swatches.js (29KB) and
   mm_product_card.liquid (36KB), which the Admin API can only replace whole.

   HOW
   - Every card's link handle is recorded when the card first appears.
   - mm-card-swatches.js sets data-current on the swatch row when a swatch is
     picked (not on hover). A MutationObserver watches for that, reads the
     handle the card's links now point to, and if it differs from what the card
     is showing, fetches /products/<handle>?view=mm-card-info (the JSON in
     templates/product.mm-card-info.liquid) and repaints .mm-card-price and
     .mm-card-fabric.
   - If that view ever comes back as HTML instead of JSON, it falls back to
     /products/<handle>.js: price is exact, fabric comes from the title.
   - Every [data-mm-quickadd] on the card is repointed too. mm-card-swatches.js
     only updates the first one (the touch button), so the desktop Quick Add
     kept opening the original colour.

   Loaded site-wide from sections/mm_card_sync.liquid in the 0_head group. */
(function () {
  if (window.__mmCardInfoBound) return;
  window.__mmCardInfoBound = true;

  var cache = {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function handleOf(href) {
    if (!href || href.indexOf("/products/") === -1) return "";
    return href.split("/products/").pop().split("?")[0].split("#")[0];
  }

  function linkHandle(card) {
    var a = card.querySelector("a[data-mm-card-link]");
    return a ? handleOf(a.getAttribute("href")) : "";
  }

  function remember(scope) {
    var cards = scope.querySelectorAll ? scope.querySelectorAll(".mm-card") : [];
    Array.prototype.forEach.call(cards, function (card) {
      if (card.__mmShown === undefined) card.__mmShown = linkHandle(card);
    });
    if (scope.classList && scope.classList.contains("mm-card") && scope.__mmShown === undefined) {
      scope.__mmShown = linkHandle(scope);
    }
  }

  function money(cents) {
    var d = Number(cents) / 100;
    var whole = d % 1 === 0;
    return "$" + d.toLocaleString("en-US", {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function fromProductJs(handle) {
    return fetch(root + "products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (p) {
        var base = String(p.title || "").split(" :: ")[0];
        var bits = base.split(" - ");
        var html = "";
        if (p.compare_at_price && p.compare_at_price > p.price) {
          html += '<s><span class="mm-sr">Original price </span>' + money(p.compare_at_price) + "</s>" +
                  '<span class="mm-sr">Sale price </span>';
        }
        html += money(p.price);
        return {
          handle: handle,
          name: bits[0].trim(),
          fabric: bits.length > 1 ? bits[bits.length - 1].trim() : null,
          price_html: html
        };
      });
  }

  function fetchInfo(handle) {
    if (cache[handle]) return cache[handle];
    var p = fetch(root + "products/" + encodeURIComponent(handle) + "?view=mm-card-info", {
      credentials: "same-origin",
      /* No Accept: application/json here. With it, Shopify ignores ?view= and
         answers with its own product JSON, which is why the old ?view=
         mm-swatches fetch "never came back as JSON". */
      headers: { "X-Requested-With": "fetch" }
    })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (text) {
        var info = JSON.parse(text.trim());
        if (!info || typeof info.price_html !== "string") throw new Error("mm-card-info: bad payload");
        return info;
      })
      .catch(function () { return fromProductJs(handle); });
    p.catch(function () { delete cache[handle]; });
    cache[handle] = p;
    return p;
  }

  function apply(card, info) {
    var box = card.querySelector(".mm-card-info");
    if (!box) return;

    var price = box.querySelector(".mm-card-price");
    if (price && typeof info.price_html === "string") price.innerHTML = info.price_html;

    var h3 = box.querySelector("h3");
    if (h3 && info.name) h3.textContent = info.name;

    if (typeof info.fabric === "string") {
      var fab = box.querySelector(".mm-card-fabric");
      if (info.fabric) {
        if (!fab && h3) {
          fab = document.createElement("p");
          fab.className = "mm-card-fabric";
          h3.parentNode.insertBefore(fab, h3);
        }
        if (fab) fab.textContent = info.fabric;
      } else if (fab) {
        fab.parentNode.removeChild(fab);
      }
    }
  }

  function sync(row) {
    var card = row.closest(".mm-card");
    if (!card) return;
    var handle = linkHandle(card);
    if (!handle) return;

    Array.prototype.forEach.call(card.querySelectorAll("[data-mm-quickadd]"), function (b) {
      b.setAttribute("data-mm-quickadd", handle);
    });

    if (card.__mmShown === undefined) card.__mmShown = handle;
    if (handle === card.__mmShown) return;

    card.__mmWant = handle;
    fetchInfo(handle).then(function (info) {
      if (card.__mmWant !== handle) return; /* a later swatch won */
      apply(card, info);
      card.__mmShown = handle;
    }, function () { /* leave the card as it is */ });
  }

  function start() {
    remember(document);
    new MutationObserver(function (records) {
      records.forEach(function (rec) {
        if (rec.type === "childList") {
          Array.prototype.forEach.call(rec.addedNodes, function (n) {
            if (n.nodeType === 1) remember(n);
          });
        } else if (rec.type === "attributes" && rec.target.hasAttribute("data-mm-card-swatches")) {
          sync(rec.target);
        }
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-current"]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
